export const stripeElementsZIndex = 1
export const stickyHeaderZIndex = 2
export const stickyFooterZIndex = 2
export const cornerRibbonZIndex = 4
/** Covers the page, sticky header included, while a file is dragged over it */
export const fullPageDropOverlayZIndex = 5
// Doc: https://mui.com/material-ui/customization/z-index/
export const tooltipZIndex = 1500
